import { useLocation } from 'react-router-dom';
import SEO from './SEO';

const metadata = {
  '/': ['Descarg? videos p?blicos de Instagram y Facebook | Video Vault', 'Guard? videos p?blicos propios o autorizados de Instagram y Facebook. Gu?as claras, privacidad y uso responsable.'],
  '/about': ['Acerca de Video Vault | Transparencia y privacidad', 'Conoc? el prop?sito, el tratamiento de URLs y nuestro compromiso con la privacidad.'],
  '/faq': ['Preguntas frecuentes | Video Vault', 'Respuestas sobre enlaces, privacidad, calidad, descargas y uso responsable.'],
  '/privacy': ['Pol?tica de privacidad | Video Vault', 'Informaci?n sobre datos, almacenamiento local, anal?tica y publicidad.'],
  '/terms': ['T?rminos de uso | Video Vault', 'Condiciones para utilizar Video Vault de forma legal y responsable.'],
  '/disclaimer': ['Aviso legal | Video Vault', 'Limitaciones, responsabilidades y relaci?n con plataformas de terceros.'],
  '/contact': ['Contacto y reportes | Video Vault', 'Contact? a Video Vault para soporte, sugerencias o reportes de derechos.'],
  '/guias': ['Gu?as para guardar y gestionar videos | Video Vault', 'Gu?as originales sobre enlaces, formatos, respaldos, privacidad y errores.']
};

const RouteSEO = () => {
  const { pathname } = useLocation();
  if (pathname.startsWith('/guias/')) return null;
  const entry = metadata[pathname];
  const title = entry?.[0] || 'P?gina no encontrada | Video Vault';
  const description = entry?.[1] || 'La p?gina solicitada no existe o cambi? de direcci?n.';
  return <SEO title={title} description={description} path={pathname} noindex={!entry} />;
};

export default RouteSEO;
